
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import { Input, InputField } from '@devsisters/ui-admin';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"input"}}>{`Input`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import Input from '@devsisters/ui-admin/lib/Input';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"사용법"}}>{`사용법`}</MDXTag>
<Playground __position={0} __code={'<State initialState={{ value: \'\' }}>\n  {({ state: { value }, setState }) => (\n    <Input\n      type=\"text\"\n      value={value}\n      placeholder=\"Input placeholder ...\"\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>'} __scope={{props: this ? this.props : props,State,Input,InputField}}>
  <State initialState={{ value: '' }}>
    {({ state: { value }, setState }) => (
      <Input
        type="text"
        value={value}
        placeholder="Input placeholder ..."
        onChange={value => setState({ value })}
      />
    )}
  </State>
</Playground>
<MDXTag name="h3" components={components} props={{"id":"비활성화"}}>{`비활성화`}</MDXTag>
<Playground __position={1} __code={'<Input disabled />'} __scope={{props: this ? this.props : props,State,Input,InputField}}>
  <Input
      disabled    
  />
</Playground>
<MDXTag name="h3" components={components} props={{"id":"오류"}}>{`오류`}</MDXTag>
<Playground __position={2} __code={'<State initialState={{ value: \'\' }}>\n  {({ state: { value }, setState }) => (\n    <Input\n      label=\"이름\"\n      type=\"text\"\n      value={value}\n      error=\"유효하지 않은 이름입니다.\"\n      placeholder=\"이름을 입력해주세요...\"\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>'} __scope={{props: this ? this.props : props,State,Input,InputField}}>
  <State initialState={{ value: '' }}>
    {({ state: { value }, setState }) => (
      <Input
        label="이름"
        type="text"
        value={value}
        error="유효하지 않은 이름입니다."
        placeholder="이름을 입력해주세요..."
        onChange={value => setState({ value })}
      />
    )}
  </State>
</Playground>
<MDXTag name="h1" components={components} props={{"id":"inputfield"}}>{`InputField`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import InputField from '@devsisters/ui-admin/lib/InputField';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"사용법-1"}}>{`사용법`}</MDXTag>
<Playground __position={3} __code={'<State initialState={{ value: \'\' }}>\n  {({ state: { value }, setState }) => (\n    <InputField\n      label=\"이름\"\n      type=\"text\"\n      value={value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>'} __scope={{props: this ? this.props : props,State,Input,InputField}}>
  <State initialState={{ value: '' }}>
    {({ state: { value }, setState }) => (
      <InputField
        label="이름"
        type="text"
        value={value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
</Playground>
           </MDXTag>
  }
}
  